import { container } from 'inversify.config';
// import { faFile, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Dimmer, Loader } from 'semantic-ui-react';
import { IdentityService } from 'services/identity-service';
import { TrainingMaterialViewModel } from 'site/pages/events/event-form/tabs/documentation/documentation-tab-pane';
import { EventTypeCategory } from 'stores/configuration/events-workflow/event-types-store';
import {
  EventDocumentUploadResult,
  EventDocumentViewModel,
  EventDocumentViewState,
  EventFormStore,
  EventFormViewModel
} from 'stores/events/event-form-store';
import { TrainingMaterialDto } from 'stores/events/events-store';
import { hasAdministrationRights, hasInstructorRights, isPocOrFactoryLeadInExtendedWf } from 'utils/event-utils';
import { FileInfo } from 'stores/types';
import { ToastComponent } from '../../util/toast-component';
import { isNullOrWhiteSpaces } from 'utils/useful-functions';

interface EventDocumentationContainerProps {
  selectedEventFormViewModel: EventFormViewModel;
  readOnly: boolean;
  eventFormStore?: EventFormStore;
}

const EventDocumentationContainer: React.FC<EventDocumentationContainerProps> = ({
  selectedEventFormViewModel,
  eventFormStore,
  readOnly
}) => {
  const { t } = useTranslation();
  const [addLink, setAddLink] = useState<boolean>(false);
  const identityService: IdentityService = container.get(IdentityService);
  const currentUserInfo = identityService.getUserInfo();
  const [addTrainingMaterial, setAddTrainingMaterial] = useState<TrainingMaterialViewModel>({
    link: '',
    title: ''
  });
  const [trainingMaterials, setTrainingMaterials] = useState<TrainingMaterialViewModel[]>(selectedEventFormViewModel.trainingMaterials);
  //const [isAddTraningMaterialOpen, setIsAddTraningMaterialOpen] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(false);

  const canEditTrainingMaterial = () => {
    //const eventForm = eventFormStore.state.item;
    const eventForm = selectedEventFormViewModel;
    return hasAdministrationRights(eventForm) || hasInstructorRights(eventForm) || isPocOrFactoryLeadInExtendedWf(eventForm);
  };

  const handleTitleChange = (value: any) => {
    let trainingMaterial = { ...addTrainingMaterial };
    trainingMaterial.title = value;
    setAddTrainingMaterial(trainingMaterial);
  };

  const handleLinkChange = (value: any) => {
    let trainingMaterial = { ...addTrainingMaterial };
    trainingMaterial.link = value;
    setAddTrainingMaterial(trainingMaterial);
  };

  const handleOnAddLinkClick = () => {
    setAddLink(true);
  };

  const handleOnCancelTrainingMaterialClick = (): void => {
    setAddTrainingMaterial({
      link: '',
      title: ''
    });
    //setIsAddTraningMaterialOpen(false);
    setAddLink(false);
  };

  const handleOnAddTrainingMaterialClick = (): void => {
    //let trainingMaterials = [...eventFormStore.state.item.trainingMaterials, addTrainingMaterial];
    let trainingMaterialsCopy = [...trainingMaterials, addTrainingMaterial];

    setAddTrainingMaterial({
      link: '',
      title: ''
    });
    //setIsAddTraningMaterialOpen(false);
    setAddLink(false);
    setTrainingMaterials(trainingMaterialsCopy);
    eventFormStore.change({ trainingMaterials: trainingMaterialsCopy });
  };

  // const renderAddLinkButton = (): React.ReactNode => {
  //   return (
  //     <>
  //       <Popup
  //         className="event-form-documentation-popup"
  //         position="bottom left"
  //         wide
  //         trigger={
  //           <Button
  //             disabled={readOnly}
  //             labelPosition="right"
  //             className="cancel-button event-form-documentation-add-link-button"
  //             basic
  //             content={t('Add Link')}
  //             icon="linkify"
  //           />
  //         }
  //         open={isAddTraningMaterialOpen}
  //         onOpen={() => setIsAddTraningMaterialOpen(true)}
  //         on="click"
  //       >
  //         <Form>
  //           <Form.Input
  //             className="event-form-documentation-popup-input"
  //             inline
  //             label={t('Title')}
  //             required
  //             onChange={(e, { value }) => {
  //               handleTitleChange(value);
  //             }}
  //           ></Form.Input>
  //           <Form.Input
  //             className="event-form-documentation-popup-input popup-url-input"
  //             inline
  //             label={t('URL')}
  //             required
  //             onChange={(e, { value }) => {
  //               handleLinkChange(value);
  //             }}
  //           ></Form.Input>
  //           <div className="event-form-documentation-popup-buttons">
  //             <Button basic className="cancel-button" content={t('Cancel')} onClick={() => handleOnCancelTrainingMaterialClick()} />
  //             <Button
  //               positive
  //               disabled={!addTrainingMaterial.link || !addTrainingMaterial.title}
  //               onClick={e => handleOnAddTrainingMaterialClick()}
  //               content={t('Add Link')}
  //             />
  //           </div>
  //         </Form>
  //       </Popup>
  //     </>
  //   );
  // };

  const handleOnRemoveTrainingMaterial = (index: number, trainingMaterial: TrainingMaterialDto) => {
    let trainingMaterialsCopy = [...trainingMaterials];
    trainingMaterialsCopy = trainingMaterialsCopy.filter((_, idx) => idx !== index);
    setTrainingMaterials(trainingMaterialsCopy);
    eventFormStore.change({ trainingMaterials: trainingMaterialsCopy });
  };

  const showSupportingDocuments = () => {
    // return EventTypeCategory[eventFormStore.state.item.eventType.eventTypeCategory] === EventTypeCategory.Extended;
    return EventTypeCategory[selectedEventFormViewModel.eventType.eventTypeCategory] === EventTypeCategory.Extended;
  };

  const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    let file: File;
    if (event && event.target && event.target.files && event.target.files.length !== 0 && event.target.files[0])
      file = event.target.files[0];
    else return;

    setShowLoading(true);
    // const { id, supportingDocuments } = eventFormStore.state.item;
    const { id, supportingDocuments } = selectedEventFormViewModel;

    const fileInfo: FileInfo = {
      fileName: file.name,
      fileSize: file.size,
      content: file,
      userId: currentUserInfo.userId,
      userName: currentUserInfo.userName
    };

    eventFormStore
      .uploadEventDocument(id, fileInfo)
      .then((result: EventDocumentUploadResult) => {
        if (result.isSuccess) {
          const next = supportingDocuments || [];
          ToastComponent({ text: t('File uploaded successfully!'), type: 'success-toast' });
          next.push({
            id: null,
            mimeType: null,
            path: result.filePath,
            state: EventDocumentViewState.Added,
            title: fileInfo.fileName
          });
          eventFormStore.change({ supportingDocuments: next });
        }
        (document.getElementById('supporting_doc_upload') as HTMLInputElement).value = '';
        setShowLoading(false);
      })
      .catch(_ => {
        (document.getElementById('supporting_doc_upload') as HTMLInputElement).value = '';
        setShowLoading(false);
        ToastComponent({ text: t('File uploaded failed'), type: 'error-toast' });
      });
  };

  // const trainingMaterials = eventFormStore?.state?.item?.trainingMaterials;
  // const documents = eventFormStore?.state?.item?.supportingDocuments || [];

  const documents = selectedEventFormViewModel.supportingDocuments || [];

  const download = (doc: EventDocumentViewModel) => {
    if (doc == null || isNullOrWhiteSpaces(doc.id)) return;
    setShowLoading(true);

    // const { id } = eventFormStore.state.item;
    const { id } = selectedEventFormViewModel;
    eventFormStore
      .downloadEventDocument(id, doc.id, doc.title)
      .then(_ => {
        setShowLoading(false);
        ToastComponent({ text: t('File download successfully!'), type: 'success-toast' });
      })
      .catch(_ => {
        setShowLoading(false);
        ToastComponent({ text: t('File download failed'), type: 'error-toast' });
      });
  };

  const handleOnRemoveDocument = (d: EventDocumentViewModel) => {
    if (readOnly) return;
    // const next = eventFormStore.state.item.supportingDocuments || [];
    const next = selectedEventFormViewModel.supportingDocuments || [];

    const key = isNullOrWhiteSpaces(d.id) ? 'path' : 'id';
    const idx = next.findIndex(x => x[key] === d[key]);
    if (idx < 0) return;

    if (!isNullOrWhiteSpaces(d.id)) next[idx].state = EventDocumentViewState.Deleted;
    else next.splice(idx, 1);

    eventFormStore.change({ supportingDocuments: next });
  };

  return (
    <div className="space-y-4">
      <>
        {showLoading && (
          <Dimmer style={{ position: 'fixed' }} active inverted>
            <Loader size="large" active inverted />
          </Dimmer>
        )}
        <div className="p-4">
          <h3 className="text-lg font-semibold mb-4">{t('Training Material')}</h3>
          {canEditTrainingMaterial() && (
            <>
              {!!!addLink ? (
                <button
                  className={`w-full ${readOnly ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
                  onClick={handleOnAddLinkClick}
                  disabled={readOnly}
                >
                  {t('Add Link')}
                </button>
              ) : (
                <>
                  <div className="mb-3">
                    <label className="block text-sm text-gray-700 mb-1">{t('Title')}</label>
                    <input
                      className="w-full p-2 border border-gray-300 rounded"
                      placeholder={t('Title')}
                      type="text"
                      onChange={e => {
                        handleTitleChange(e.target.value);
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="block text-sm text-gray-700 mb-1">{t('URL')}</label>
                    <input
                      className="w-full p-2 border border-gray-300 rounded"
                      placeholder={t('URL')}
                      type="text"
                      onChange={e => {
                        handleLinkChange(e.target.value);
                      }}
                    />
                  </div>
                  <button className="w-full bg-primary-600 text-white py-2 rounded mt-2" onClick={handleOnCancelTrainingMaterialClick}>
                    {t('Cancel')}
                  </button>
                  <button
                    className={`w-full ${
                      !addTrainingMaterial.link || !addTrainingMaterial.title ? 'bg-gray-600' : 'bg-primary-600'
                    } text-white py-2 rounded mt-2`}
                    disabled={!addTrainingMaterial.link || !addTrainingMaterial.title}
                    onClick={handleOnAddTrainingMaterialClick}
                  >
                    {t('Add Link')}
                  </button>
                </>
              )}
            </>
          )}
        </div>

        <div className="p-4">
          {trainingMaterials.map((trainingMaterial, index) => {
            return (
              <div className="mb-3">
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <a href={trainingMaterial.link} target="_blank" rel="noopener noreferrer" className="text-black-600 hover:underline">
                    {trainingMaterial.title}
                  </a>
                  {canEditTrainingMaterial() && !readOnly && (
                    <svg
                      className="w-5 h-5 text-gray-600 flex-shrink-0"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      onClick={() => handleOnRemoveTrainingMaterial(index, trainingMaterial)}
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 15v3c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1v-3M3 15V6c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.5061-7.4939L12 10m0 0 1.5061-1.50614M12 10l1.5061 1.5061M12 10l-1.5061-1.50614"
                      />
                    </svg>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {showSupportingDocuments() && (
          <>
            <div className="p-4">
              <h3 className="text-lg font-semibold mb-4">{t('Supporting Documents')}</h3>

              {canEditTrainingMaterial() && (
                <>
                  <button
                    className={`w-full ${readOnly ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
                    onClick={() => document.getElementById('supporting_doc_upload').click()}
                    disabled={readOnly}
                  >
                    {t('Add Document')}
                  </button>
                  <input hidden style={{ display: 'none' }} id="supporting_doc_upload" type="file" onChange={onChangeFile} />
                </>
              )}
            </div>

            <div className="p-4">
              <div className="mb-3">
                {documents
                  .filter(d => d.state !== EventDocumentViewState.Deleted)
                  .map(d => {
                    return (
                      <div className="mb-3">
                        <div className="flex items-center gap-2 text-sm text-gray-700">
                          {isNullOrWhiteSpaces(d.id) ? (
                            <p className="block text-sm text-gray-700 mb-1">{d.title}</p>
                          ) : (
                            <a
                              href="javascript:void(0);"
                              onClick={() => download(d)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-black-600 hover:underline"
                            >
                              {d.title}
                            </a>
                          )}
                          {canEditTrainingMaterial() && !readOnly && (
                            <svg
                              className="w-5 h-5 text-gray-600 flex-shrink-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              onClick={() => handleOnRemoveDocument(d)}
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M3 15v3c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1v-3M3 15V6c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.5061-7.4939L12 10m0 0 1.5061-1.50614M12 10l1.5061 1.5061M12 10l-1.5061-1.50614"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};
export default connect(['eventFormStore', EventFormStore])(EventDocumentationContainer);
